import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './config';


const root = ReactDOM.createRoot(document.getElementById('root'));

window.collectMissing = true;
window.missingLang = {};
window.defaultLang = 'en';
window.langData = {};

window.l = (s) => {
	let lang;

	try {
		lang = window.localStorage.getItem('currentLang');
	}
	catch (e) {
		lang = window.defaultLang;
	}

	if (window.collectMissing) {
		if (lang != window.defaultLang && !window.langData[s]) {
			window.missingLang[s] = '';
		}
	}

	return lang == window.defaultLang ? s : window.langData[lang] && window.langData[lang][s] ? window.langData[lang][s] : s;
};

window.getCurrentLang = () => {
	let lang;

	try {
		lang = window.localStorage.getItem('currentLang');
	}
	catch (e) {
		lang = window.defaultLang;
	}

	return lang;
}

function renderApp() {
	root.render(
	  <React.StrictMode>
		<App />
	  </React.StrictMode>
	);
}

let f_key = 'arni_apograf';

function authenticate() {
	let input = window.prompt('Diplomatarium Arnamagnæanum password');

	if (input == f_key) {
		renderApp();

		localStorage.setItem('f_key', f_key);
	}
	else {
		authenticate();
	}
}

if (typeof localStorage !== 'undefined') {
	if (localStorage.getItem('f_key') && localStorage.getItem('f_key') == f_key) {
		renderApp();
	}
	else {
		authenticate();
	}
}
else {
	renderApp();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();